<template>
  <!--促销商品页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    hide-status-bar
    :style="{background: bgColor}"
    @refresh="refreshInit"
    ref="resetPromotionalGifts"
    @scroll="watchScroll"
    @loadingMore="getPromotionalGifts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="!isHeaderColor" :icon-name="'return'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">推荐商品</div>
    </gradient-header>
    <!--背景图渲染-->
    <div class="limited-bg" :style="`background-image: url(${bgSrc}) !important`"></div>
    <!--为你推荐-->
    <div class="p-x-12 m-t-24">
      <linear-card
        :width="100" :height="50"
        :linear-bottom-color="'#FFFFFF'"
        :linear-top-color="'#FFA48A'"
        :commodity-arr="recommendedGifts"
        :type="'promotionalGifts'"
        :title="'为你推荐'"
        :is-more="false"
      >
        <tk-flex wrap class="p-x-12 p-y-8" gutter="5" v-if="recommendedGifts.length">
          <commodity-three-row
            v-for="(s, index) in recommendedGifts"
            :key="index"
            :commodity="s"
            :selling-color="'#999'"
            :selling-bg="'rgba(255, 255, 255, 0)'"
          >
          </commodity-three-row>
        </tk-flex>
        <empty-tips v-else :height="150" :width="100" :empty-msg="'暂无推荐数据'"></empty-tips>
      </linear-card>
    </div>
    <!--列表展示-->
    <template v-if="promotionalGifts.length">
      <!--全部礼品数据渲染-->
      <div class="p-x-12 m-t-8">
        <linear-card
          class="p-b-8"
          :width="100" :height="50"
          :linear-bottom-color="'rgba(255,255,255,0)'"
          :linear-top-color="'#FFE4CA'"
          :commodity-arr="promotionalGifts"
          :type="'promotionalGifts'"
          :title="'全部商品'"
          :is-more="false"
        >
          <tk-flex wrap v-if="promotionalGifts.length">
            <lookCommodity
              class="m-t-8 p-x-12"
              v-for="(s, index) in getPriceProcessing(promotionalGifts, judgeTimeRule)"
              :key="index"
              :commodity="s"
              :selling-color="'#999'"
              :selling-bg="'rgba(255, 255, 255, 0)'"
              :is-border="false"
              :is-raised="true"
              :is-rounded="true"
              :bg-color="'#FF9B38'"
            >
            </lookCommodity>
          </tk-flex>
          <empty-tips v-else :height="100" :width="100" :empty-msg="'暂无数据'"></empty-tips>
        </linear-card>
      </div>
    </template>
  </tk-container>
</template>

<script>
import linearCard from '@/components/linearCard'
import lookCommodity from '@/components/lookCommodity'
import commodityThreeRow from '@/components/commodityThreeRow'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    linearCard,
    lookCommodity,
    commodityThreeRow
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      checkDisabled: false, // 签到按钮状态
      themeBackground: null, // 主题背景图片
      recommendedGifts: [], // 为你推荐数据
      promotionalGifts: [], // 促销礼品数据
      timeRule: {} // 限时抢购时间规则
    }
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    },
    // 装饰图src
    decorationSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.decoration)) { return '' }
      return this.themeBackground.decoration
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  methods: {
    /**
     * 数据初始化
     * @date: 2020/4/11
     */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getRecommendedGifts() // 获取为你推荐数据
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.promotionalGifts = []
      await this.getInit()
      this.$refs.resetPromotionalGifts.resetInfiniteScroll()
    },
    /**
     * 获取主题图片
     * @date: 2020/4/11
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            position: 'promotionalGifts'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/4/11
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
    * 为你推荐按销量排序
    * @date: 2020/4/27
    */
    async getRecommendedGifts () {
      let id = '80dkpxb8rC'
      if (!id) { return }
      let recommendedGifts = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 6,
          order: '-sales',
          where: {
            category: id,
            shelvesStatus: 'shelves'
          }
        }
      })
      if (recommendedGifts.length) { this.recommendedGifts = priceProcessing(recommendedGifts, this.judgeTimeRule) } else { this.recommendedGifts = [] }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    // /**
    //  * 促销礼品类别Id数据获取
    //  * @date: 2020/3/20
    //  */
    // async getGiftsClassId () {
    //   let className = await this.$tkParse.getList(`/classes/secondaryClassification`, {
    //     params: {
    //       limit: 1,
    //       where: {
    //         name: '促销礼品'
    //       }
    //     }
    //   })
    //   return className.length ? className[0].objectId : null
    // },
    /**
     * 促销礼品数据获取
     * @date: 2020/3/20
     */
    async getPromotionalGifts (page, next) {
      let id = '80dkpxb8rC'
      if (!id) { return next('complete') }
      let promotionalGifts = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          // order: '-updatedAt',
          order: 'weight',
          where: {
            category: id,
            shelvesStatus: 'shelves'
          }
        }
      })
      this.promotionalGifts = [...this.promotionalGifts, ...priceProcessing(promotionalGifts, this.judgeTimeRule)]
      if (promotionalGifts.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
  .limited-bg {
    width: 100%;
    min-height: 190px;
    padding-top: 60px;
    background-repeat:  no-repeat;
    background-size: 100% 100%;
  }
  ::v-deep .before-trigger {
    color: #fff !important;
  }
</style>
